import React from "react";
import { Filter as RaFilter, ReferenceInput, SelectInput } from "react-admin";
import SearchInput from "../components/inputs/SearchInput";
import { useFiltersStyles } from "../components/lists/useStyles";

const Filters = (props) => {
	const classes = useFiltersStyles();
	return (
		<RaFilter {...props} classes={classes}>
			<SearchInput source="q" alwaysOn fullWidth variant="outlined" />
			<ReferenceInput
				source="language_id"
				reference="languages"
				alwaysOn
				fullWidth
				variant="outlined"
			>
				<SelectInput optionText="name" />
			</ReferenceInput>
		</RaFilter>
	);
};
export default Filters;
